import { useEffect, useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { ApiService } from "./ApiService";
import { Button, Card, Col, Descriptions, Image, message, Result, Row, Spin, Typography } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { Header } from "antd/es/layout/layout";
import Logo from "./assets/img.png";
import { CheckCircle2 } from "lucide-react";
import UtilityService from "./UtilityService";
const { Title } = Typography;

function CallBack() {
    const [searchParams] = useSearchParams();
    const code = searchParams.get('code');
    const state = searchParams.get('state');
    const error = searchParams.get('error');
    const error_description = searchParams.get('error_description');
    const [customer, setCustomer] = useState(null);
    const [loading, setLoading] = useState(true);
    const [items, setItems] = useState([]);
    const [baseUrl, setBaseUrl] = useState("https://apps.hijradigital.com/fayda");

    const navigate = useNavigate();
    const [messageApi, contextHolder] = message.useMessage();

    useEffect(() => {
        setLoading(true);
        const temp = UtilityService.decrypt(state);
        const channel = temp.split(":")[1];

        const fetchData = async () => {
            try {
                const response = await ApiService.fetchCustomerInfo({ code, state, channel });
                const { status, ob } = response;

                if (status === true) {
                    setCustomer(ob);
                    window.history.replaceState({}, document.title, window.location.pathname);
                } else {
                    messageApi.error(response.message);
                }
            } catch (error) {
                messageApi.error(error.message || "An error occurred");
            } finally {
                setLoading(false);
            }
        };

        if (!error) {
            fetchData();
        } else {
            setLoading(false);
            messageApi.error(error_description);
            window.history.replaceState({}, document.title, window.location.pathname);
        }
    }, [code, state, error, error_description]);

    useEffect(() => {
        if (!customer) return;

        const constructItems = async () => {
            setItems([
                {
                    key: '1',
                    label: 'Customer Name',
                    children: `${customer.name}`,
                },
                {
                    key: '2',
                    label: 'Gender',
                    children: `${customer.gender}`,
                },
                {
                    key: '3',
                    label: 'Birth Date',
                    children: `${customer.birthdate}`,
                },
                {
                    key: '4',
                    label: 'Phone Number',
                    children: `${customer.phoneNumber}`,
                },
                {
                    key: '5',
                    label: 'Email',
                    children: `${customer.email}`,
                },
                {
                    key: '6',
                    label: 'Address',
                    children: (
                        <>
                            Country: {customer.address?.country}
                            <br />
                            Region: {customer.address?.region}
                            <br />
                        </>
                    ),
                }
            ]);
        }

        constructItems();
    }, [customer]);

    const openFayda = () => {
        const encodedState = encodeURIComponent(
            btoa(JSON.stringify(customer))
        );

        const url = `https://accounts.hijra-bank.com/onboarding/fayda/callback?state=${encodedState}`;
        window.open(url, '_self');
    };

    return (
        <>
            {contextHolder}
            {!loading && customer ? (
                <>
                    <Header
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            backgroundColor: '#fff',
                            height: 'auto',
                            padding: '0 24px'
                        }}
                    >
                        <div style={{ marginRight: '24px', cursor: 'pointer' }}>
                            <Link to="/">
                                <img
                                    src={Logo}
                                    alt="Logo"
                                    style={{ width: '100px', height: '100px', objectFit: 'contain' }}
                                />
                            </Link>
                        </div>
                        <Title level={3} style={{ margin: 0, color: '#1890ff' }}>
                            <Link to="/" style={{ color: 'inherit', textDecoration: 'none' }}>
                                Home
                            </Link>
                        </Title>
                    </Header>

                    {customer.registeredBy === "branch" || customer.registeredBy === "new" ? (
                        <div style={{
                            padding: '24px',
                            maxWidth: '1200px',
                            margin: 'auto',
                            backgroundColor: '#f9f9f9',
                            borderRadius: '12px',
                            boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                        }}>
                            <div style={{ textAlign: 'center', marginBottom: '24px' }}>
                                <Title level={2} style={{ color: '#1890ff', fontWeight: '500' }}>
                                    Customer Details
                                </Title>
                            </div>

                            <Row gutter={[32, 16]}>
                                <Col xs={24} md={12}>
                                    <Card
                                        title={
                                            <span style={{ fontWeight: 'bold', color: '#1890ff', fontSize: '16px' }}>
                                                Customer Information
                                            </span>
                                        }
                                        variant={"borderless"}
                                        style={{ borderRadius: '10px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}
                                    >
                                        <Descriptions
                                            column={2}
                                            layout="vertical"
                                            items={items}
                                            labelStyle={{
                                                fontWeight: '600',
                                                color: '#1f1f1f',
                                                backgroundColor: '#fafafa'
                                            }}
                                        />
                                    </Card>
                                </Col>

                                <Col xs={24} md={12}>
                                    <Card
                                        title={
                                            <span style={{ fontWeight: 'bold', color: '#1890ff', fontSize: '16px' }}>
                                                Customer Photo
                                            </span>
                                        }
                                        bordered={false}
                                        style={{ borderRadius: '10px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}
                                    >
                                        <div style={{ display: 'flex', justifyContent: 'center', padding: '16px' }}>
                                            <Image
                                                src={baseUrl + customer.picture}
                                                alt="Customer"
                                                width={200}
                                                height={250}
                                                style={{ borderRadius: '8px' }}
                                                preview={true}
                                                fallback="https://via.placeholder.com/200x200?text=No+Image"
                                            />
                                        </div>
                                    </Card>
                                </Col>
                            </Row>
                        </div>
                    ) : customer.registeredBy === "onboarding_web" ? (
                        openFayda()
                    ) : (<Card
                        className="shadow-lg border-slate-100 text-center py-8"
                        variant={"borderless"}
                        style={{ maxWidth: '600px', margin: '40px auto', padding: '2rem' }}
                    >
                        <Result
                            icon={<CheckCircle2 className="w-20 h-20 text-green-500 mx-auto" style={{ color: '#10b981' }} />}
                            title={
                                <div style={{ fontSize: '1.75rem', fontWeight: '600', color: '#1f2937', marginBottom: '1rem' }}>
                                    Thank You! Verification Complete
                                </div>
                            }
                            subTitle={
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', marginTop: '1.5rem' }}>
                                    <p style={{ fontSize: '1.1rem', color: '#374151', margin: 0 }}>
                                        We appreciate you taking the time to verify your identity with us.
                                    </p>
                                    <p style={{
                                        fontWeight: '600',
                                        color: '#10b981',
                                        marginTop: '0.5rem',
                                        fontSize: '1.1rem',
                                        margin: 0
                                    }}>
                                        You're all set! Welcome aboard.
                                    </p>
                                </div>
                            }
                        />
                    </Card>)}
                </>
            ) : (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh' }}>
                    <Spin indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />} />
                </div>
            )}
        </>
    );
}

export default CallBack;